var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['check-radio']},[_c('div',{class:['radio-container'],style:({})},[_c('span',{staticClass:"radio__prefix"},[_vm._t("prefix")],2),_vm._v(" "),(_vm.$slots.custom_suffix)?_c('div',{staticClass:"radio__custom__suffix"},[_vm._t("custom_suffix")],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ad20220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reception/checkPrice/components/CheckFrame.vue
// module id = null
// module chunks = 